import React, { Component } from 'react';
import axios from 'axios';


/**
 * Notice Feed.
 *
 * @component
 */
const NoticeFeed = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // ---------- state: ----------
    state = {
        notices: [],
        instanceUrl: ''
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        // fetch notice data:
        this.getNotices();
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    /**
     * Click handler for POST request to mark/unmark notice.
     *
     * @param notice { object }
     * @return undefined: submits POST request.
     */
    markNoticeOnClick = (notice) => {
        axios.post(
            '/settings/notices/mark',
            {
                id: notice.id,
                viewed: !notice.viewed // toggled viewed state
            },
            {
                cancelToken: this.source.token
            })
            // after notice has been successfully marked, we need to update the UI:
            .then((res) => {
                const updatedNotices = [...this.state.notices];

                // find the element in the array that has been marked, and set the state to this updated array:
                // this is faster than calling another GET for all of the notices.
                const arrIndex = updatedNotices.findIndex(updatedNotice => notice.id === updatedNotice.id);

                updatedNotices[arrIndex] = Object.assign(updatedNotices[arrIndex], {viewed: !notice.viewed});

                this.setState({
                    notices: updatedNotices
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(POST) Error:\n', err);
                }
            });
    }

    /**
     * GET request for fetching all notices.
     */
    getNotices = () => {
        axios.post(
            '/settings/notices',
            {},
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    notices: res.data
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(POST) Error:\n', err);
                }
            });

        // get instance url:
        axios.get(
            '/sf/instanceUrl',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    instanceUrl: res.data.instanceUrl
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error:\n', err);
                }
            });
    }

    render() {
        return (
            <table>
                <tbody>
                {
                    this.state.notices.map(notice => {
                        return (
                            <tr key={notice.id}>
                                <td>
                                    <span
                                        className={ !notice.viewed ? 'text-danger cursor-pointer' : 'cursor-pointer' }
                                        onClick={() => this.markNoticeOnClick(notice)}
                                    >{ notice.type }</span>
                                </td>
                                <td>{ notice.rep }</td>
                                {/* TODO: to get the proper href, we need to get the `instanceUrl` -- see JSForce */}
                                <td><a href={ `${this.state.instanceUrl}/${notice.sfId}` } target="_blank" rel="noopener noreferrer">View in SF</a></td>
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    };
};

export default NoticeFeed;
